<main>
	<sb-wrapper>
		<router-outlet />
	</sb-wrapper>
</main>
